'use client';
import { useRouter } from 'next/navigation';
import { useEffect } from 'react';

import handleGA4Event from '@/lib/service-workers';

import Alert from '@/components/@base/alert';
import Container from '@/components/@base/container';
import { showToast } from '@/components/@base/toast/show-toast';
import Actions from '@/components/app/cart/components/actions';
import Discount from '@/components/app/cart/components/discount';
import Gateways from '@/components/app/cart/components/gateways';
import Header from '@/components/app/cart/components/header';
import List from '@/components/app/cart/components/list';
import Prices from '@/components/app/cart/components/prices';
import { useGetCart } from '@/components/app/cart/services/hooks';
import Background from '@/components/shared/components/background';

import imagesList from '@/constant/images-list';
import localization, { pageLevelLocalization } from '@/constant/localization';

const { cart: cartLocalization } = pageLevelLocalization;
export default function Cart() {
  const { data, isLoading } = useGetCart();
  const router = useRouter();
  useEffect(() => {
    if (data) {
      let cartViewListData = data?.products?.map((product, index) => {
        return {
          item_id: product?.id,
          item_name: product?.title,
          price: product.price,
          affiliation: product?.store?.slug,
          discount: product?.discount,
          index: 0,
          quantity: 1,
        };
      });
      handleGA4Event('view_cart', cartViewListData, {
        currency: 'USD',
        value: data?.total,
      });
      if (data.productsPriceChangedInCart) {
        showToast({ message: data.productsPriceChangedInCart, type: 'default' });
      }
      if (data.deletedUnsellableProductsInCart) {
        showToast({ message: data.deletedUnsellableProductsInCart, type: 'default' });
      }
    }
  }, [data]);
  return (
    <Container className='relative'>
      <Background src={imagesList.backgrounds.cartBg} className='h-[141px]! w-full!' />
      <Container className='mx-auto mt-[26px] mb-[100px] w-full bg-white p-4 md:max-w-[1057px] md:shadow-[0px_20px_60px_-15px_rgba(0,0,0,0.15)]'>
        <Header />
        <Container className='flex flex-col rounded-md pb-[15px] shadow-[0px_25px_40px_0px_rgba(73,75,84,0.1)] md:flex-row md:justify-between md:gap-[39px] md:pb-0 md:shadow-none'>
          {data && data?.products?.length === 0 && !isLoading ? (
            <Container className='mt-[24px] w-full pb-[300px]'>
              <Alert
                message={cartLocalization.cartIsEmpty}
                type='info'
                buttonText={localization.viewProducts}
                buttonOnClick={() => router.push('/search?sort_by="top_sales"')}
                buttonTextClassName='sm:text-[15px]! text-[10px]! whitespace-nowrap'
                messageClassName='sm:text-[15px]! text-[12px]! whitespace-nowrap'
                className='mx-auto h-[63px] w-[95%] px-2 py-[21px] shadow-[0px_10px_25px_0px_#969BA41A] sm:px-[19px]'
              />
            </Container>
          ) : (
            <>
              <Container className='md:flex md:w-full md:flex-col md:justify-between'>
                <List />
                <Discount />
              </Container>
              <Container className='top-[10%] h-max w-full md:sticky md:max-w-[348px] md:p-5 md:pt-0'>
                <Prices />
                <Gateways />
                <Actions />
              </Container>
            </>
          )}
        </Container>
      </Container>
    </Container>
  );
}
